export function fromBase64Url(input) {
    return Uint8Array.from(atob(input.replace(/[_-]/g, (char) => (char === "_" ? "/" : "+"))), (char) => char.codePointAt(0));
}
export function toBase64Url(input) {
    return btoa(Array.from(input, (byte) => String.fromCodePoint(byte)).join(""))
        .replace(/[/+]/g, (char) => (char === "/" ? "_" : "-"))
        .replace(/=+$/, "");
}
//# sourceMappingURL=base64url.client.js.map